/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A filtering enum for review messages.
 */
export const ReviewMessageTypeFilter = {
    All: 1,
    ClaimOnly: 2,
    ContractOnly: 3
} as const;
export type ReviewMessageTypeFilter = typeof ReviewMessageTypeFilter[keyof typeof ReviewMessageTypeFilter];

